import { atom } from 'jotai';
import { type SelectedFilterChipsModalItems } from 'libs/common/models/filterChipsModal';

import { MarketplaceModalFilterTabs } from '../../models';

export const MarketplaceSelectedChipsFilterAtom = atom<SelectedFilterChipsModalItems>({
	[MarketplaceModalFilterTabs.Sports]: [],
	[MarketplaceModalFilterTabs.Teams]: []
});
